import { type ButtonProps, Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const CardRemoveBtn = ({ className, 'aria-label': ariaLabel = 'Remove', ...props }: ButtonProps) => {
	// Theme
	const rootClassName = cn('absolute -top-1.5 -right-1.5 z-10 rounded-full', className);

	// Render
	return (
		<Button variant='outline' size='icon-xs' aria-label={ariaLabel} {...props} className={rootClassName}>
			<Icon data-icon='inline-start' type='far' icon='xmark' aria-hidden />
		</Button>
	);
};

export { CardRemoveBtn };
